import { render, staticRenderFns } from "./Articlecontent.vue?vue&type=template&id=55d06ed2&scoped=true"
import script from "./Articlecontent.vue?vue&type=script&lang=js"
export * from "./Articlecontent.vue?vue&type=script&lang=js"
import style0 from "./Articlecontent.vue?vue&type=style&index=0&id=55d06ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d06ed2",
  null
  
)

export default component.exports